import Campos from '../images/campos.jpg';


export default function About() {
  return (
    <section id="sobre" className="relative overflow-hidden">
      {/* Green textured background */}
      <div className="green-section relative grain">
        <div className="relative z-10 max-w-3xl mx-auto px-5 py-20 md:py-28 text-center">
          <span className="reveal inline-block text-xs tracking-[0.2em] uppercase text-brand-gold font-body font-semibold mb-6">
            Nossa missão
          </span>

          <p className="reveal font-body text-xl md:text-2xl lg:text-3xl text-white/90 leading-relaxed" data-delay="100">
            Trabalhamos com{' '}
            <strong className="text-brand-gold font-semibold">pontualidade</strong>, organização e
            execução eficiente, garantindo que cada carga chegue no{' '}
            <strong className="text-brand-gold font-semibold">prazo</strong>, com{' '}
            <strong className="text-brand-gold font-semibold">segurança</strong> e{' '}
            <strong className="text-brand-gold font-semibold">previsibilidade</strong>.
          </p>

          <div className="reveal mt-10" data-delay="200">
            <a
              href="https://wa.me/11946384844"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-white/80 hover:text-brand-gold font-body font-medium text-sm transition-colors duration-300 group"
            >
              Saiba mais
              <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </a>
          </div>
        </div>

        {/* Decorative background image (optional: user replaces) */}
        <div className="absolute inset-0 z-0">
          <img
            src={Campos}
            alt="Campos Transportes"
            aria-hidden="true"
            className="w-full h-full object-cover opacity-30"
            onError={(e) => e.target.style.display = 'none'}
          />
        </div>
      </div>

      {/* Feature row below */}
      <div className="bg-white">
        <div className="max-w-5xl mx-auto px-5 py-16 grid sm:grid-cols-3 gap-8">
          {[
            {
              icon: (
                <svg className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
              ),
              title: 'Pontualidade',
              desc: 'Seu produto entregue exatamente quando combinado, sem atrasos.',
            },
            {
              icon: (
                <svg className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
                </svg>
              ),
              title: 'Segurança',
              desc: 'Carga protegida com rastreamento em tempo real durante toda a rota.',
            },
            {
              icon: (
                <svg className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
                </svg>
              ),
              title: 'Previsibilidade',
              desc: 'Planejamento completo para que você tenha total controle das operações.',
            },
          ].map((item, i) => (
            <div key={item.title} className="reveal card-lift text-center px-4 py-8 rounded-sm border border-gray-100 hover:border-brand-gold/40 transition-colors" data-delay={i * 100}>
              <div className="w-14 h-14 rounded-full bg-brand-green/8 flex items-center justify-center mx-auto mb-5 text-brand-green">
                {item.icon}
              </div>
              <h3 className="font-display font-bold text-xl text-brand-dark mb-2">{item.title}</h3>
              <p className="font-body text-sm text-gray-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
